export default ['$rootScope', function ($rootScope) {
    let property;

    const get = (param) => {
        if (!property) {
            property = $rootScope.currentProperty;
        }

        return getParameter(param);
    };

    const getParameter = (param) => {
        switch (param) {
            case 'loadStaff':
                return !!(property.setting
                    && property.setting.core
                    && property.setting.core.load_staff);
            case 'hasIntegration':
                return !!property.integration;
        }

        return property[param];
    };

    return {
        get
    };
}];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/property/services/property.service.js